.back-to-merchant-button {
  display: flex;
  justify-content: center;

  a {
    color: oklch(0.551 0.0234 264.36);
    font-size: 1.4rem;
    font-weight: 600;
    text-decoration: none;

    display: inline-flex;
    align-items: center;
    gap: 8px;

    padding: 0.8rem 1.4rem;
    border-radius: 2rem;

    transition:.15s;

    &:hover {
      background-color: oklch(0.9609 0.0163 17.44);
      color: oklch(0.6349 0.1948 24.59);
    }
  }
}
